import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      "&:hover": {
        backgroundColor: theme.palette.grey.A100,
      },
    },
    buttonGrid: {
      textAlign: "end",
      alignSelf: "flex-end",
    },
    button: {
      marginBottom: theme.spacing(0.2),
      marginLeft: theme.spacing(0.7),
    },
    title: {
      color: theme.palette.grey.A700,
    },
    icon: {
      marginRight: 10,
      paddingTop: 5,
    },
  })
);
